import { useQuery } from "hooks/useQuery";
import { getActiveHoldings } from "features/Strategy/service";

export const useActiveHoldings = (strategyId) => {
  return useQuery({
    key: "activeHoldings",
    queryKey: ["activeHoldings", strategyId],
    queryFn: async () => {
      const response = await getActiveHoldings(strategyId);
      return response;
    },
    enabled: !!strategyId,
  });
};
